import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { OrderStatus } from '@websky/graphql';
import { useConfig } from '@websky/core/src/context';
import Checkbox from './Checkbox/Checkbox';
const PassengerToolbarAdditional = ({ order }) => {
    var _a, _b, _c;
    const { t } = useTranslation('Checkout');
    const { subsidyRulesUrl, transferBaggageUrl } = useConfig().global.companyInfo;
    const hasSubsidizedMessage = (_a = order.messages) === null || _a === void 0 ? void 0 : _a.find(message => message.code === 'Subsidized1' || message.code === 'Subsidized2');
    const hasSvxMessage = (_b = order.messages) === null || _b === void 0 ? void 0 : _b.find(message => message.code === 'mvlsvx');
    if (!order ||
        order.status !== OrderStatus.New ||
        !((_c = order.messages) === null || _c === void 0 ? void 0 : _c.length) ||
        !(hasSubsidizedMessage || hasSvxMessage)) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        hasSubsidizedMessage && (React.createElement(Checkbox, { name: "subsidyCheck", label: t('I agree with subsidy fares and rules', { subsidyUrl: subsidyRulesUrl }) })),
        hasSvxMessage && (React.createElement(Checkbox, { name: "transferCheck", label: t('I agree with the rules for checking in transfer baggage at Koltsovo airport', {
                transferBaggageUrl
            }) }))));
};
export default PassengerToolbarAdditional;
